import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import {
  laChannelCount,
  laDiscountPriceMonthly,
  latinoPlanData,
} from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'
import styled from 'styled-components'

export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'es' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null

  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="es"
        market="latino"
        //REMOVED: univision_removed video and annotations
        // video={videos.latino.videoUrl}
        // annotations={videos.latino.annotations}
        //REPLACED: univision_removed poster images
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title={
          <>
            Ahorra en TV <span className="no-wrap">en vivo para</span>{' '}
            <span className="no-wrap">toda la familia</span>
          </>
        }
        subtitle={
          <>
            Más de {laChannelCount} canales con deportes, noticias y{' '}
            <span className="desktop-line-break">
              entretenimiento en español desde solo{' '}
              <span className="green-underline">${laDiscountPriceMonthly}</span> el primer mes.
            </span>
          </>
        }
        networkSet={'entertainmentLatino'}
        noteLink="/latino/"
        disableLAPlanCards={isLatinoBundleAvailable}
        forceAnchorLink={isLatinoBundleAvailable}
        hasPlanCards={isLatinoBundleAvailable}
        plans={[latinoBundlePlan, latinoPlanData.latino_es_standalone_monthly]}
        plansSharedData={{
          rsn: latinoBundlePlan?.rsn,
          teams: latinoBundlePlan?.teams,
        }}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
